import { Tabs, ConfigProvider } from 'antd';
import { useEffect, useState } from 'react';

/**
 *
 * @returns
 */
export const BaseTabs = ({ items, defaultKey, setTab }) => {
  const [activeKey, setActiveKey] = useState(defaultKey);

  const onChange = (key) => {
    setActiveKey(key);
    if (setTab) setTab(key);
  };
  useEffect(() => {
    setActiveKey(defaultKey);
  }, [defaultKey]);

  return <Tabs defaultActiveKey={defaultKey} activeKey={activeKey} destroyInactiveTabPane onChange={onChange} items={items}></Tabs>;
};

export const RoundTabs = ({ items, defaultKey, activeKey = undefined, onChange = undefined, setTab }) => {
  const [active, setActive] = useState(defaultKey);

  const onChangeTab = (key) => {
    console.log(key);
    setActive(key);
    if (setTab) setTab(key);
  };
  useEffect(() => {
    setActive(defaultKey);
  }, [defaultKey]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            inkBarColor: 'transparent',
            itemActiveColor: 'transparent'
          }
        }
      }}
    >
      <Tabs className="round-tab" defaultActiveKey={defaultKey} activeKey={activeKey || active} onChange={onChange || onChangeTab} items={items}></Tabs>
    </ConfigProvider>
  );
};
